import "../LogIn/styles.less";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { useContext } from "react";
import { Logo } from "../../Logo/web";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { useMutation } from "@apollo/client";
import { UPDATE_USER_MUTATION } from "../User.querys";
import { firstLetterToUppercase } from "src/utils/Functions";

const Mandatory = ({ onOk, user }) => {
	const { translations } = useContext(ConfigStateContext);
	const [updateUserMutation, { loading }] = useMutation(UPDATE_USER_MUTATION);

	const onFinish = async (values: any) => {
		try {
			await updateUserMutation({ variables: { name: values.name.trim(), phone: values.phone } });
			onOk(values);
		} catch (error) {
			console.error("Error updating user:", error);
		}
	};

	const Title = () => (
		<Typography.Title level={4}>{`${firstLetterToUppercase(translations.ingresa)} los siguientes datos para continuar`}</Typography.Title>
	);

	const PhoneInput = (
		<Form.Item
			style={{ marginTop: "1em" }}
			name="phone"
			label="Teléfono"
			rules={[
				{ required: true, message: "Ingrese un número de teléfono" },
				{ min: 8, message: "El número de teléfono debe tener al menos 8 caracteres" },
				{ pattern: /^\d+$/, message: "Ingrese solo números" },
			]}
		>
			<Input
				className="input-phone"
				placeholder="Ingrese un número de teléfono (móvil o fijo)"
				required
			/>
		</Form.Item>
	);

	const NameInput = (
		<Form.Item
			style={{ marginTop: "1em" }}
			name="name"
			label="Nombre"
			rules={[
				{ required: true, message: "Por favor ingrese un nombre" },
			]}
		>
			<Input
				className="input-name"
				placeholder={`${firstLetterToUppercase(translations.ingresa)} tu nombre`}
				required
			/>
		</Form.Item>
	);

	const FormButton = () => (
		<Button
			className="btn-access"
			type="primary"
			htmlType="submit"
			loading={loading}
		>
			Continuar
		</Button>
	);

	return (
		<Row justify="center" gutter={[0, 0]} className="auth-content">
			<Col className="brand login-space">
				<Logo type="desktop" />
			</Col>

			<Col className="title" span={24}>
				<Title />
			</Col>

			<Col span={24}>
				<Form
					className="auth-form"
					layout="vertical"
					onFinish={(e: any) => { onFinish(e) }}
					initialValues={{ phone: user?.me?.phone, name: user?.me?.name }}
				>

					{!user?.me?.phone && PhoneInput}
					{!user?.me?.name && NameInput}
					<FormButton />
				</Form>
			</Col>
		</Row>
	);
};

export default Mandatory;
